module.exports = __webpack_public_path__ + "img/9788932021829.e49533cc.jpg";